import React, { useState, useEffect, useRef } from 'react';
import menuIcon from '../../../../Assets/images/menu.svg';
import styles from './TherapistHeader.module.css';

const TherapistHeader = ({ therapist, onArchive, onUnarchive }) => {
    const [showMenu, setShowMenu] = useState(false);
    const menuRef = useRef(null);

    const getGenderColor = (gender) => {
        return gender?.toLowerCase() === 'female' ? 'female' : 'male';
    };

    // Function to get status indicator class based on check-in/out status
    const getStatusIndicator = (therapist) => {
        const hasCheckedIn = therapist?.daily_checkin !== null && therapist?.daily_checkin !== undefined;
        const hasCheckedOut = therapist?.daily_checkout !== null && therapist?.daily_checkout !== undefined;
        
        if (hasCheckedIn && hasCheckedOut) {
            return 'checkedOut'; // Red dot - checked out
        } else if (hasCheckedIn) {
            return 'checkedIn'; // Green dot - checked in
        }
        return null; // No dot
    };

    const toggleMenu = () => {
        setShowMenu(!showMenu);
    };

    // Close menu when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setShowMenu(false);
            }
        };

        if (showMenu) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showMenu]);

    return (
        <div className={styles.therapistHeader}>
            <div className={styles.headerContent}>
                <div className={styles.avatarSection}>
                    <div className={`${styles.avatar} ${styles[getGenderColor(therapist?.gender)]}`}>
                        {therapist?.pager_number  || 'N/A'}
                    </div>
                    <h2 className={styles.therapistName}>
                        {therapist?.alias || therapist?.name || 'Select a therapist'}
                        {therapist && getStatusIndicator(therapist) && (
                            <span className={`${styles.statusIndicator} ${styles[getStatusIndicator(therapist)]}`}></span>
                        )}
                    </h2>
                </div>
                
                {therapist && (
                    <div className={styles.menuContainer} ref={menuRef}>
                        <button 
                            className={styles.menuButton}
                            onClick={toggleMenu}
                            aria-label="More options"
                        >
                            <img src={menuIcon} alt="Menu" className={styles.menuIcon} />
                        </button>
                        
                        {showMenu && (
                            <div className={styles.dropdownMenu}>
                                {therapist?.status === 0 ? (
                                    onUnarchive && (
                                        <button 
                                            className={styles.menuItem}
                                            onClick={() => {
                                                onUnarchive();
                                                setShowMenu(false);
                                            }}
                                        >
                                            Unarchive 
                                        </button>
                                    )
                                ) : (
                                    onArchive && (
                                        <button 
                                            className={styles.menuItem}
                                            onClick={() => {
                                                onArchive();
                                                setShowMenu(false);
                                            }}
                                        >
                                            Archive 
                                        </button>
                                    )
                                )}
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default TherapistHeader;

